import {Component, OnInit, inject, signal, TemplateRef} from '@angular/core';
import {DataService} from "../../services/data.service";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";
import {JitsiComponent} from "../../components/jitsi.component";
import {AccessService} from "../../services/access.service";
import {PaginationComponent} from "ngx-bootstrap/pagination";
import {FormsModule} from "@angular/forms";
import {YesNoPipe} from "../../pipes/yes-no.pipe";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-franchisee-list',
    imports: [RouterLink, NgIf, JitsiComponent, PaginationComponent, FormsModule, YesNoPipe],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-handshake me-2"></i>Franchisenehmer <small class="text-muted">({{totalEntries}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/franchisee', 0]">Franchisenehmer anlegen</button>
                <button type="button" class="btn btn-outline-secondary mb-3 float-end ms-2" (click)="exportCSV()"><i class="fa-solid fa-file-csv me-1"></i>CSV exportieren</button>
                <button type="button" class="btn btn-outline-secondary mb-3 float-end" (click)="showEmails(emailsModal)"><i class="fa-solid fa-mail-bulk me-1"></i>E-Mail Adressen anzeigen</button>

                <pagination
                    [hidden]="entries?.length == 0"
                    [totalItems]="totalEntries"
                    [itemsPerPage]="paginConfig.itemsPerPage"
                    [(ngModel)]="paginConfig.page"
                    (pageChanged)="listEntries($event)"
                    [maxSize]="20"
                    previousText="Letzte"
                    nextText="Nächste">
                </pagination>

                @if (entries?.length > 0) {
                    <div class="table-responsive">
                        <table class="table table-striped table-hover mb-0 pointer">
                            <thead>
                            <tr>
                                <th (click)="setOrder('name')">
                                    Name <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('country')">
                                    Land <i class="fa-solid" *ngIf="predicate == 'country'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('zip')">
                                    PLZ <i class="fa-solid" *ngIf="predicate == 'zip'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('city')">
                                    Ort <i class="fa-solid" *ngIf="predicate == 'city'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('street')">
                                    Straße <i class="fa-solid" *ngIf="predicate == 'street'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('contact')">
                                    Kontakt <i class="fa-solid" *ngIf="predicate == 'contact'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('phone')">
                                    Telefon <i class="fa-solid" *ngIf="predicate == 'phone'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('email')">
                                    E-Mail <i class="fa-solid" *ngIf="predicate == 'email'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('stores')">
                                    # Stores <i class="fa-solid" *ngIf="predicate == 'stores'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                                <th (click)="setOrder('has_user')">
                                    Connect Benutzer <i class="fa-solid" *ngIf="predicate == 'has_user'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (entry of entries; track entry.id) {
                                    <tr [routerLink]="['/franchisee', entry.id]">
                                        <td>{{ entry.name }}</td>
                                        <td>{{ entry.country }}</td>
                                        <td>{{ entry.zip }}</td>
                                        <td>{{ entry.city }}</td>
                                        <td>{{ entry.street }}</td>
                                        <td>{{ entry.contact }}</td>
                                        <td>
                                            @if (entry.phone) {
                                                <a (click)="$event.stopPropagation()" [href]="'tel:' + entry.phone">{{ entry.phone }}</a>
                                                <a class="ms-3" (click)="$event.stopPropagation()" [href]="'https://wa.me/' + entry.phone"><i class="fa-brands fa-whatsapp text-success"></i></a>
                                                @if (accessService.environmentIsDev()) {
                                                    <app-jitsi [id_franchisee]="entry.id" [phone]="entry.phone" [contact]="entry.contact"/>
                                                }
                                            }
                                        </td>
                                        <td>
                                            @if (entry.email) { <a (click)="$event.stopPropagation()" [href]="'mailto:' + entry.email">{{ entry.email }}</a> }
                                        </td>
                                        <td>{{ entry.stores }}</td>
                                        <td>{{ entry.has_user | yesNo }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>

        <ng-template #emailsModal>
            <div class="modal-header">
                <h4 class="modal-title">E-Mail Adressen</h4>
                <button type="button" class="btn-close" (click)="modalRef?.hide()"></button>
            </div>
            <div class="modal-body">
                <textarea class="form-control" rows="10" readonly>{{ emails() }}</textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="copyEmails()"><i class="fa-solid fa-copy me-1"></i>Kopieren</button>
                <button type="button" class="btn btn-secondary" (click)="modalRef?.hide()">Schließen</button>
            </div>
        </ng-template>
    `
})
export class FranchiseeListComponent implements OnInit {

    accessService = inject(AccessService);
    private dataService = inject(DataService);
    private modalService = inject(BsModalService);
    private toastrService = inject(ToastrService);
    modalRef?: BsModalRef;

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1
    };
    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'name';
    search: any = {
        text: ''
    };
    reverse = false;

    emails = signal<string>('');

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: string): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Franchisee/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.franchisees;

            this.entries.forEach(entry => {
                entry.has_user = entry.has_user == 1;
            });
        });
    }

    exportCSV(): void {
        this.dataService.request('Franchisee/exportCSV').subscribe(response => {
            if (response && response.file) {
                this.dataService.generateBlob(response);
            }
        });
    }

    protected showEmails(template: TemplateRef<any>) {
        this.dataService.request('Franchisee/getEmails').subscribe(response => {
            this.emails.set(response.emails);
            this.modalRef = this.modalService.show(template, {class: 'modal-lg'});
        });
    }

    copyEmails(): void {
        navigator.clipboard.writeText(this.emails());
        this.toastrService.success('E-Mail Adressen kopiert', 'Kopieren');
    }
}
